<template>
  <div style="height: 400px; max-width: 100%; width: 99%;">
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import { Bar } from 'vue-chartjs'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'HorizontalStackedBarChart',
  components: { Bar },
  props: {
    labels: { type: Array, required: true }, // ej: ['Pos A', 'Pos B', 'Pos C']
    success: { type: Array, required: true }, // ej: [95, 80, 600]
    canceled: { type: Array, required: true }, // ej: [5, 4, 20]
    sections: { type: Array, required: true } // ej: ['Success', 'Cancell']
  },
  computed: {
    chartData () {
      // Convertimos a porcentaje total por barra
      const total = this.labels.map((_, i) => this.success[i] + this.canceled[i])
      const successPercent = this.success.map((v, i) => (v / total[i]) * 100)
      const canceledPercent = this.canceled.map((v, i) => (v / total[i]) * 100)

      return {
        labels: this.labels,
        datasets: [
          {
            label: this.sections[0],
            data: successPercent,
            backgroundColor: '#64D80D'
          },
          {
            label: this.sections[1],
            data: canceledPercent,
            backgroundColor: '#EF4444'
          }
        ]
      }
    },
    chartOptions () {
      return {
        indexAxis: 'y', // Esto hace que las barras sean horizontales
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'top' },
          title: { display: false },
          tooltip: {
            callbacks: {
              label: function (context) {
                return `${context.dataset.label}: ${context.raw.toFixed(1)}%`
              }
            }
          }
        },
        scales: {
          x: {
            stacked: true,
            max: 100,
            ticks: { callback: value => value + '%' }
          },
          y: { stacked: true }
        }
      }
    }
  }
}
</script>
